import { ChainId } from '@pancakeswap/sdk'
import { chainTokens } from './tokens'
import { PoolCategory, PoolChainConfig } from './types'


const pools: PoolChainConfig = {
  [ChainId.FANTOM_TESTNET]:
  [
 {
    sousId: 0,
    stakingToken: chainTokens.lum,
    earningToken: chainTokens.lum,
    title: `${chainTokens.lum.symbol} Pool`,
    contractAddress: {
      4002: '0xB5834d35F784E18Ea6efc8F32A53388e87c998c1'
    },
    poolCategory: PoolCategory.CORE_MASTER,
    harvest: true,
    tokenPerSecond: '0.1162', // TODO tokenPerSecond
    sortOrder: 1,
    isFinished: false,

  },
/*  {
    sousId: 10, // masterchef pid
    stakingToken: chainTokens.magicLum,
    earningToken: chainTokens.lum,
    title: `MagicLum Pool`,
    contractAddress: {
      4002: '0xcA83685a3506243DBB9e804815d2851569475d21'
    },
    poolCategory: PoolCategory.CORE_MASTER,
    harvest: true,
    tokenPerSecond: '0.545', // TODO tokenPerSecond
    sortOrder: 3,
    isFinished: false,

  }, */
   {
    sousId: 10,
    title: `LUM Pool`,
    subtitle: `Stake LUM. LUMI NFT holders only`,
    stakingToken: chainTokens.lum,
    earningToken: chainTokens.lum,
    NFTIcon: 'Lumi_Icon_NFT_Pool_Badge', // the name of the file (SVG) on bunnys image store
    contractAddress: {
      4002: '0xD75d1BE9B3158376c7b71729f498a1BA458814EA'
    },
    poolCategory: PoolCategory.CORE_NFT_RESTRICTED,
    harvest: true,
    tokenPerSecond: '0.1129',
    sortOrder: 2,
    isFinished: false,
    nft: {
      4002: '0x7fe06E0397F928B1ee26Bf019B0eCbe91fA11b4c'
    }
  },
  {
    sousId: 100,
    stakingToken: chainTokens.bolt,
    earningToken: chainTokens.bolt,
    title: `$${chainTokens.bolt.symbol} Pool`,
    contractAddress: {
      4002: '0x3000c46341bEce98b4bF2765E472E1190Ee3dA41'
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerSecond: '0.07',
    sortOrder: 2,
    isFinished: false
  },
  ],

  // shimmer_evm
  [ChainId.SHIMMER]: [
    {
      sousId: 0,
      stakingToken: chainTokens.lum,
      earningToken: chainTokens.lum,
      title: `$${chainTokens.lum.symbol} Pool`,
      contractAddress: {
        1073: '0x4794Aeafa5Efe2fC1F6f5eb745798aaF39A81D3e'
      },
      poolCategory: PoolCategory.CORE_MASTER,
      harvest: true,
      tokenPerSecond: '0.07',
      sortOrder: 1,
      isFinished: false,

    },
    {
      sousId: 100,
      stakingToken: chainTokens.bolt,
      earningToken: chainTokens.bolt,
      title: `$${chainTokens.bolt.symbol} Pool`,
      contractAddress: {
        1073: '0xcF46079519c39c760AAbC1Ef047db86661CcE2ac',
      },
      poolCategory: PoolCategory.CORE,
      harvest: true,
      tokenPerSecond: '0.07',
      sortOrder: 1,
      isFinished: false,
    }
  ]
}

export default pools
